// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1D4LS","colMaxWidth":"Table_colMaxWidth__3PTle"};